import { HelmetProvider } from 'react-helmet-async';
import { ParallaxProvider } from 'react-scroll-parallax';
import { ThemeProvider } from 'next-themes';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import Header from '@/components/landing/Header';
import Hero from '@/components/landing/Hero';
import Features from '@/components/landing/Features';
import HowItWorks from '@/components/landing/HowItWorks';
import Demo from '@/components/landing/Pricing';
import Security from '@/components/landing/Security';
import CTA from '@/components/landing/CTA';
import Footer from '@/components/landing/Footer';

export default function Landing() {
  // Initialize Calendly badge widget only on landing page
  useEffect(() => {
    const initCalendlyBadge = () => {
      if ((window as any).Calendly) {
        (window as any).Calendly.initBadgeWidget({ 
          url: 'https://calendly.com/lucas-camargo-bloom-scouting/30min', 
          text: 'Book Your Demo', 
          color: '#0891b2', 
          textColor: '#ffffff' 
        });
      } else {
        // If Calendly script hasn't loaded yet, wait and try again
        setTimeout(initCalendlyBadge, 500);
      }
    };

    // Small delay to ensure scripts are loaded
    const timer = setTimeout(initCalendlyBadge, 100);

    // Cleanup: destroy badge widget when leaving landing page
    return () => {
      clearTimeout(timer);
      if ((window as any).Calendly && (window as any).Calendly.destroyBadgeWidget) {
        (window as any).Calendly.destroyBadgeWidget();
      }
    };
  }, []);
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <ParallaxProvider>
          <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
            <Header />
            <Hero />
            <Features />
            <HowItWorks />
            <Demo />
            <Security />
            <CTA />
            <Footer />
            <Toaster position="top-right" />
          </div>
        </ParallaxProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}
